<template lang="html">

  <form id="formNewsletter" @submit.prevent="validateBeforeSubmit" class="suscripcionNewsletter ">
    <p class="title waypoints" data="fadeInUp">Suscríbete a EL MÁSTIL</p>
    <p class="waypoints" data="fadeInUp">Reflexiones sobre entrenamiento, mentalidad estoica y fuerza a largo plazo.  
      Recursos prácticos. Sin agobios ni cuentas atrás inventadas.</p>
    <section class="d-flex row-between ais waypoints" data="fadeInUp">
      <p :enviado="enviado" class="gracias" v-if="enviado">¡Gracias!<br>
        Se ha suscrito a la newsletter, pronto recibirás nuestras novedades. </p>
      <p class="error" v-else-if="error">
        Hubo un problema al enviar el mensaje. Intenta nuevamente. 
      </p>
      <div class="section-inputs" v-else>
        <div class="contenedor-input">
          <input type="text" class="input-text" v-validate="'required|email'" name="email" id="emailNewsletter"
            placeholder="Email*" />
          <span :class="['error', { 'animated shake': clicked }]" v-if="clicked">{{ errors.first('email')
          }}</span>
        </div>
        <div class="contenedor-input policy">
          <input name="politicaNewsletter" type="checkbox" id="politicaNewsletter" value="1" v-validate="'required'">
          <label for="politicaNewsletter">Acepto la <u><router-link to="/politica-de-privacidad">Política de
                Privacidad</router-link></u></label>
          <span :class="['error', { 'animated shake': clicked }]" v-if="clicked">{{ errors.first('politicaNewsletter')
          }}</span>
        </div>

      </div>
      <button :enviado="enviado" class="btn row-center" :loading="loading"
        :disabled="loading"><span>Suscríbete</span></button>
    </section>
    <input type="hidden" name="from" value="web">
    <input type="hidden" name="newsletter" value="1">

  </form>

</template>

<script lang="js">


import Vue from 'vue';
import VeeValidate from 'vee-validate';

Vue.use(VeeValidate);

import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'formulario',
  props: [],
  mounted() {

  },
  data() {
    return {
      clicked: false,
      loading: false,
      enviado: false,
      error: false
    }
  },
  methods: {
    ...mapActions(['suscribeNewsletter']),
    validateBeforeSubmit: function () {
      this.clicked = true;
      this.$validator.validateAll().then(canSend => {
        if (canSend) {
          this.loading = true;
          this.suscribeNewsletter($("#formNewsletter").serialize())
            .then(result => {
              setTimeout(() => {
                this.loading = false;
                this.enviado = true;
                $("#formNewsletter")[0].reset();
              }, 1000);
            }).catch(() => {
              setTimeout(() => {
                this.loading = false;
                this.enviado = false;
                this.error = true;
                $("#formNewsletter")[0].reset();
              }, 1000);
            });
          setTimeout(() => {
            this.error = false;
            this.enviado = false;
          }, 5000);
        }
      });
    },

  },
  computed: {

  }
}
</script>

<style scoped lang="scss">
#formNewsletter {
  position: relative;
  width: 100%;
  padding: 20px;

  @media screen and(max-width:600px) {
    padding: 20px 0;
  }

  .title {
    font-size: 40px;
    line-height: 1em;

    @media screen and(max-width:900px) {
      font-size: 30px;
    }

    @media screen and(max-width:600px) {
      font-size: 22px;
    }
  }

  .section-inputs {
    width: calc(100% - 170px);

    @media screen and(max-width:700px) {
      width: 100%;
    }
  }

  button {
    max-height: 50px;
    max-width: 160px;
  }

  .contenedor-input {
    &.policy {
      margin: 30px 0 10px 0;
      text-align: left;

      input {
        margin-bottom: 0;

        &:focus {
          border: 1px solid black;
        }
      }

      label {
        cursor: pointer;
      }
    }

    input,
    textarea {
      width: 100%;
      border: none;
      border-bottom: 1px solid black;
      padding: 35px 0 15px 0;
      font-size: 18px;
      background: transparent;
      margin-bottom: 5px;

      @media screen and(max-width:600px) {
        font-size: 16px;
      }

      &[type="checkbox"] {
        border: 1px solid black;
        width: 15px;
        height: 15px;
        padding: 0;
      }

      &:checked {
        background: url("/static/img/tick-pink.svg");
        background-repeat: no-repeat;
        background-position: center center;
        background-size: 80%;
      }

      &:focus {
        border: none;
        outline: none;
        border-bottom: 1px solid black;
      }
    }

    textarea {
      height: 175px;
    }

    ::placeholder {
      color: gray;
      font-size: 18px;

      @media screen and(max-width:600px) {
        font-size: 16px;
      }
    }

    label {
      color: black;
      font-size: 16px;
      font-weight: bold;

    }

    .small {
      width: 96%;
      font-size: 11px;
      margin-left: 19px;
      line-height: 16px;
      margin-top: 9px;
      color: gray;

      @media (max-width: 1280px) {
        margin-left: 0px;
      }

      a {
        text-decoration: underline;
      }
    }

    .error {
      color: #de0a2f;
      top: 0;
      left: 5px;
      position: relative;
      font-weight: bold;
      font-size: 15px;
      text-align: left;
      width: 100%;
      float: left;
    }
  }

  .gracias {
    height: 55px;
    text-align: left;
    width: 100%;
    opacity: 0;
    pointer-events: none;
    color: #8bc34a;
    font-weight: bold;
    font-family: "GothamBold";
    text-transform: uppercase;
    font-size: 18px;
    line-height: 25px;
    transition: opacity 0.5s ease-in-out;
    -moz-transition: opacity 0.5s ease-in-out;
    -webkit-transition: opacity 0.5s ease-in-out;
  }

  .gracias[enviado="true"] {
    opacity: 1;
    transition: opacity 0.5s ease-in-out;
    -moz-transition: opacity 0.5s ease-in-out;
    -webkit-transition: opacity 0.5s ease-in-out;
  }

  .error {
    height: 55px;
    text-align: left;
    width: 100%;
    pointer-events: none;
    color: #dd1616;
    font-weight: bold;
    font-family: "GothamBold";
    text-transform: uppercase;
    font-size: 18px;
    line-height: 25px;
    transition: opacity 0.5s ease-in-out;
    -moz-transition: opacity 0.5s ease-in-out;
    -webkit-transition: opacity 0.5s ease-in-out;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/parts/suscripcionNewsletter.vue